import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { Field } from "formik";

export const DivStyle = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  border: none;
`;

export const InputDiv = styled(Box)`
  width: 100%;
  height: 3rem;
  border-radius: 20px;
  background-color: #f4f4f4;
  padding: 0 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

// New container specifically for textarea
export const TextAreaDiv = styled(Box)`
  width: 100%;
  min-height: 100px;
  border-radius: 20px;
  background-color: #f4f4f4;
  padding: 5px;
`;

export const FieldStyle = styled(Field)`
  outline: 0;
`;

export const InputStyle = styled("input")`
  outline: 0;
  font-size: 13px;
  font-weight: 500;
  font-family: "Geologica", sans-serif;
  font-family: "Outfit", sans-serif;
  width: 100%;
  background: transparent;
  border: none;
`;

export const DateStyle = styled("input")`
  outline: 0;
  font-size: 13px;
  font-weight: 500;
  font-family: Poppins;
  border: 0;
  width: 100%;
  font-family: "Geologica", sans-serif;
  background: transparent;
  padding: 0 7px;
`;

export const SelectStyle = styled("select")`
  display: inline-block;
  width: 100%;
  height: 2.5rem;
  padding: 3px 6px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Geologica", sans-serif;
  font-family: "Outfit", sans-serif;
  line-height: 20px;
  color: #555555;
  outline: 0;
  background-color: #f4f4f4;
  border: none;
  vertical-align: middle;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
`;

export const TextAreaStyle = styled.textarea`
  width: 100%;
  min-height: 90px;
  max-height: 200px;
  resize: vertical;
  padding: 12px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Geologica", sans-serif;
  font-family: "Outfit", sans-serif;
  color: #555555;
  background-color: transparent;
  border: none;
  border-radius: 20px;
  outline: none;
  box-sizing: border-box;
  line-height: 1.5;

  &:focus {
    outline: none;
  }

  /* For webkit browsers */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const InputPlainStyle = {
  border: "none",
  borderBottom: "none",
  outline: "none",
  boxShadow: "none",
  background: "#F5F5F5",
  padding: "6px",
  paddingLeft: "10px",
  borderRadius: "20px",
  fontSize: "13px",
  width: "100%",
  "&:not(.Mui-focused)": {
    borderColor: "transparent",
  },
};
